import { useQuery } from '@tanstack/react-query';
import type { AxiosRequestConfig } from 'axios';
import { apiWrapper } from '@/apiWrapper';
import { getEndpoints } from '@/endpoints';
import type { RelevanceSearchResult } from '../types/RelevanceSearchResult';

type RelevanceSearchApiResponse = {
  results: (Omit<RelevanceSearchResult, 'id'> & {
    _id: string;
  })[];
};

const getRelevanceSearch = async (
  search: string,
  useNewDest?: boolean,
): Promise<RelevanceSearchResult[]> => {
  const url = getEndpoints().relevanceSearch;
  const config: AxiosRequestConfig = {
    method: 'GET',
    params: {
      q: search,
      ...(useNewDest && { useNewDest: 'true' }),
    },
  };

  const { results } = await apiWrapper<RelevanceSearchApiResponse>(url, config);
  return results.map((e) => ({
    ...e,
    id: e._id,
  }));
};

export const useRelevanceSearch = (search: string, useNewDest?: boolean) => {
  return useQuery({
    queryKey: ['relevanceSearch', search, useNewDest],
    queryFn: () => (search ? getRelevanceSearch(search, useNewDest) : []),
    staleTime: Number.POSITIVE_INFINITY,
  });
};
